import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import userService from './userService'

const initialState = {
  users: null,

  userError: null,
  userLoading: null,
}

// @desc Get Users
export const getUsers = createAsyncThunk(
  'user/get',
  async (token, thunkAPI) => {
    try {
      return await userService.getUsers(token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc POST Add Users
export const addUser = createAsyncThunk(
  'user/add',
  async ({ data, token }, thunkAPI) => {
    try {
      return await userService.addUser(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc UPDATE Users
export const updateUser = createAsyncThunk(
  'user/update',
  async ({ data, token }, thunkAPI) => {
    try {
      return await userService.updateUser(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

// @desc DELETE Users
export const deleteUser = createAsyncThunk(
  'user/delete',
  async ({ data, token }, thunkAPI) => {
    try {
      return await userService.deleteUser(data, token)
    } catch (error) {
      return thunkAPI.rejectWithValue(error)
    }
  }
)

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    resetUsers: (state) => {
      state.users = null
      state.userError = null
    },
  },
  extraReducers: (builder) => {
    builder
      // GET User
      .addCase(getUsers.pending, (state) => {
        state.userLoading = true
      })
      .addCase(getUsers.fulfilled, (state, action) => {
        state.users = action.payload.res.data
        state.userLoading = false
      })
      .addCase(getUsers.rejected, (state, action) => {
        state.userError = action.payload.response.data
        state.userLoading = false
      })
      // ADD User
      .addCase(addUser.pending, (state) => {
        state.userLoading = true
      })
      .addCase(addUser.fulfilled, (state) => {
        state.userLoading = false
      })
      .addCase(addUser.rejected, (state, action) => {
        state.userError = action.payload.response.data
        state.userLoading = false
      })
      // UPDATE User
      .addCase(updateUser.pending, (state) => {
        state.userLoading = true
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.userLoading = false
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.userError = action.payload.response.data
        state.userLoading = false
      })
      // DELETE User
      .addCase(deleteUser.pending, (state) => {
        state.userLoading = true
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.userLoading = false
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.userError = action.payload.response.data
        state.userLoading = false
      })
  },
})

export const { resetUsers } = userSlice.actions

export default userSlice.reducer
